import Component from '../core/Component'
import EventBus from '../core/EventBus'
import support from '../utils/BrowserSupport'

const STATES = {
    DISABLED: 'is-disabled'
}

export default class Overlay extends Component {

    constructor(element) {
        super(element)

        this.state = {
            disabled: false,
            forceDisabled: false
        }
    }

    prepare() {
        EventBus.on('nav:open', this.handleNavOpen)
        EventBus.on('nav:afterclose', this.handleNavClose)
        EventBus.on('swup:animationoutstart', this.handleSwupAnimationOutStart)
        EventBus.on('swup:transitionend', this.handleSwupTransitionEnd)
    }

    destroy() {
        EventBus.off('nav:open', this.handleNavOpen)
        EventBus.off('nav:afterclose', this.handleNavClose)
    }

    handleNavOpen = () => {
        this.state.disabled = true
        this.render()
    }

    handleNavClose = () => {
        this.state.disabled = false
        this.render()
    }

    handleSwupAnimationOutStart = () => {
        this.state.forceDisabled = this.state.disabled
        this.render()
    }

    handleSwupTransitionEnd = () => {
        this.state.forceDisabled = false
        this.render()
    }

    render() {
        if (this.state.disabled || this.state.forceDisabled) {
            this.element.classList.add(STATES.DISABLED)
        }

        if (!this.state.disabled && !this.state.forceDisabled) {
            this.element.classList.remove(STATES.DISABLED)
        }
    }
}
